import React from 'react';
import { ReactComponent as HelpIcon } from 'assets/icons/help.svg';
import Tippy from '@tippyjs/react';
const OrganizeItem = ({ text, onClick }: { text: string; onClick?: () => void }) => {
  return (
    <Tippy
      placement='bottom-start'
      content={
        <p className='bg-white border border-gray-11 p-2 shadow-lg rounded'>
          Drag and drop to reorder {text}
        </p>
      }>
      <div
        className='cursor-pointer flex text-gray-8 text-xs items-center gap-[3px] py-[6px] px-[10px] rounded-[20px] border border-[#E8E8E8]'
        onClick={onClick}>
        <HelpIcon />
        Organize {text}
      </div>
    </Tippy>
  );
};

export default OrganizeItem;
